import { IStatusCodes } from "../../api/tenantCommunityInboxPost";

export const eventCategoriesAr = {
  "Shop & Dine": "التسوق وتناول الطعام",
  "Interactivity": "التفاعل",
  "Wellness": "الصحة",
  "Community": "المجتمع"
};

export const directoryCategoriesEn = {
  "Fine Dining": "Fine Dining",
  "Casual Dining": "Casual Dining",
  "Cafes and Coffee Shops": "Cafés",
  "Entertainment": "Entertainment",
  "Shopping": "Shopping",
  "Health and Wellness": "Health and Wellness",
  "Services": "Services",
};

export const directoryCategoriesAr = {
  "Fine Dining": "المطاعم الراقية",
  "Casual Dining": "المطاعم المتنوعة",
  "Cafes and Coffee Shops": "المقاهي",
  "Entertainment": "الترفية",
  "Shopping": "التسوق",
  "Health and Wellness": "الصحة والرفاهية",
  "Services": "خدمات",
};

export const directoryStatusAr = {
  Available: "متاح",
  "Not Available": "غير متاح",
};

export const statusesAr = {
  [IStatusCodes.Pending]: "تحت المراجعة",
  [IStatusCodes.Published]: "تم النشر",
  [IStatusCodes.Rejected]: "تم الرفض من قبل المشرف",
  [IStatusCodes.Scheduled]: "مجدولة"
};
